import React, {useState, useEffect} from 'react';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import '../../pages/CategoriasSevicios/CategoriasServicios.css';
import {HeadCategoriasServicios} from './HeadCategoriasServicios';
import axios from 'axios';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import {CardCategoria} from './CardCategoria';
import {CardServicio} from './CardServicio';

export const ContentBodyCategoriasServicios = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the TipoNotificaciones variable to an array of strings. */
	const [Seleccion, setSeleecion] = useState([
		['buttonNotificacionesActive', 'Categorias'],
		['buttonNotificaciones', 'Servicios'],
	]);
	/**
	 * It takes a number as an argument and then sets the state of the component to a list of strings,
	 * where the string at the index of the number argument is set to a different string
	 */
	const cambioSeleccion = (num) => {
		let listaAxu = [
			['buttonNotificaciones', 'Categorias'],
			['buttonNotificaciones', 'Servicios'],
		];
		listaAxu[num] = ['buttonNotificacionesActive', listaAxu[num][1]];
		setSeleecion(listaAxu);
	};

	const [CategoriasPosibles, setCategoriasPosibles] = useState([]);

	const [ServiciosPosibles, setServiciosPosibles] = useState([]);

	const [filtroNombre, setFiltroNombre] = useState('');

	const [ListaSuperCategorias, setListaSuperCategorias] = useState([]);
	const [ListaNombreSuperCategorias, setListaNombreSuperCategorias] = useState([]);
	useEffect(() => {
		let listaAxu = [];
		let listaAxu2 = [];
		axios({
			method: 'get',
			url: window.ipdirection + 'superCategoria/',
		}).then((response) => {
			response.data.map((superCategoria) => {
				listaAxu.push({...superCategoria});
				listaAxu2.push(superCategoria.nombre);
			});
			setListaSuperCategorias(listaAxu);
			setListaNombreSuperCategorias(listaAxu2);
		});
	}, []);
	const definirServicios = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'servicioAdmin/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				let listaAxu = [];
				response.data.map((servicio) => {
					listaAxu.push({
						id: servicio.id,
						nombre: servicio.nombre,
						categoria_id: {
							id: servicio.categoria_id.id,
							nombre: servicio.categoria_id.nombre,
						},
					});
				});
				setServiciosPosibles(listaAxu);
			})
			.catch((error) => {
				console.log(error.response);
			});
	};

	const definirCategorias = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'categoria/',
		}).then((response) => {
			let listaAxu = [];
			response.data.map((categoria) => {
				listaAxu.push({
					...categoria,
				});
			});
			setCategoriasPosibles(listaAxu);
		});
	};

	const definirCategoriasServicios = () => {
		definirCategorias();
		definirServicios();
	};

	useEffect(() => {
		definirCategorias();
		definirServicios();
	}, []);

	return (
		<>
			<MenuLateralAB
				seleccionado={8}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentUserFeedback'>
				<div className='derContentUserFeedback'>
					<HeadCategoriasServicios
						Seleccion={Seleccion}
						cambioSeleccion={cambioSeleccion}
						CategoriasPosibles={CategoriasPosibles}
						definirCategoriasServicios={definirCategoriasServicios}
						definirServicios={definirServicios}
						filtroNombre={filtroNombre}
						setFiltroNombre={setFiltroNombre}
						ListaSuperCategorias={ListaSuperCategorias}
						ListaNombreSuperCategorias={ListaNombreSuperCategorias}
					/>
					<div className='lista-categorias'>
						{Seleccion[0][0] === 'buttonNotificacionesActive'
							? CategoriasPosibles.map(
									(categoria) =>
										categoria.nombre
											.toLowerCase()
											.includes(filtroNombre.toLowerCase()) && (
											<CardCategoria
												categoria={categoria.nombre}
												superCategoria={categoria.superCategoria}
												id={categoria.id}
												definirCategoriasServicios={
													definirCategoriasServicios
												}
												ListaSuperCategorias={ListaSuperCategorias}
												ListaNombreSuperCategorias={
													ListaNombreSuperCategorias
												}
											/>
										)
							  )
							: ServiciosPosibles.map(
									(servicio) =>
										(servicio.nombre
											.toLowerCase()
											.includes(filtroNombre.toLowerCase()) ||
											servicio.categoria_id.nombre
												.toLowerCase()
												.includes(filtroNombre.toLowerCase())) && (
											<CardServicio
												servicio={servicio}
												definirCategoriasServicios={
													definirCategoriasServicios
												}
												CategoriasPosibles={CategoriasPosibles}
											/>
										)
							)}
					</div>
				</div>
			</div>
		</>
	);
};
